// extracted by mini-css-extract-plugin
module.exports = {"root":"SurveyList_root_k3Xrh","headerItem":"SurveyList_headerItem_15isn"};